const STORAGE_KEY = 'glyphicai-composer-expanded'

/** 读取提示词面板展开状态，默认展开 */
export function readStoredComposerExpanded(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === null) return true
    return v === 'true'
  } catch {
    return true
  }
}

/** 持久化提示词面板展开状态 */
export function persistComposerExpanded(expanded: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(expanded))
  } catch {
    /* ignore */
  }
}
